import { forwardRef, type SVGProps } from "react";

/**
 * Bullseye with an arrow in the centre. Custom icon drawn in Lucide style
 * (24px grid, 2px stroke, round caps) since Lucide has no arrow-in-target icon.
 * Used for the brand's Primary Category or Niche.
 */
export const TargetArrow = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & { strokeWidth?: number }>(
  ({ strokeWidth = 2, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      {/* Rings, opened at the top-right where the arrow enters */}
      <path d="M20.6 9.5A9 9 0 1 1 14.5 3.4" />
      <path d="M16.9 11A5 5 0 1 1 13 7.1" />
      {/* Arrow shaft into the centre */}
      <path d="M12 12 19 5" />
      {/* Fletching */}
      <path d="M16 5V2l3 3 3 0-3 3h-3" />
    </svg>
  ),
);
TargetArrow.displayName = "TargetArrow";
